import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-tobe-approved-list',
  templateUrl: './tobe-approved-list.component.html',
  styleUrls: ['./tobe-approved-list.component.css']
})
export class TobeApprovedListComponent implements OnInit {

  form: any | FormGroup
  editForm: any | FormGroup
  modelSubtitle = false
  checked = false
  name = ""
  version = ""
  isActive = false
  data: any =[];
  ECdata: any = [];
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  cid:any
  isLoading: any = false
  imageUrl:any = ""
  isEditEC: boolean = false

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    this.getAllECRequests();
    this.form = this.fb.group({
      existingCustomerInfoId: [''],
      userId: ['']
    })  

    this.editForm = this.fb.group({
      name: ['',[Validators.required]],
      installationAddress: ['',[Validators.required]],
      email: ['',[Validators.required]],
      customerId: ['',[Validators.required]]
    })
  }

  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton3")?.click()
  }

  onTableDataChange(event: any) {
    this.page = event;
    this.getAllECRequests();
  }
  onTableSizeChange(event: any): void {
    this.tableSize = event.target.value;
    this.page = 1;
    this.getAllECRequests();
  }

  getAllECRequests(){
    this.isLoading = true
    
    this.generic_service.getExistingCustomerByStatus('REQUESTED').subscribe(
      (response:any)=>{
        this.ECdata = response.response;
        this.count = response.response.length;
        this.isLoading = false

        console.log(response)
      }
    )
  }

  getECbyId(id:any){
    this.data = []

    this.generic_service.getExistingCustomerById(id).subscribe(
      (res:any)=>{
        this.data = [];
        console.log(res);
        this.data.push(res.response);
        console.log(this.data);

        this.form.patchValue(
          {
            existingCustomerInfoId: res.response.existingCustomerInfoId,
          }
        );

        this.editForm.patchValue(
          {
            name: res.response.name,
            installationAddress: res.response.installationAddress,
            email: res.response.email,
            customerId: res.response.customerId
          }
        );
      }
    )
  }

  approveEC(){
    let body = {
      "customerId": this.data[0].existingCustomerInfoId,
      "cid": this.data[0].cid,
      "existingCustomerInfoStatus": {
        "note": "",
        "status": "VERIFIED",
        "updatedDate": 0
      }
    }
    console.log(body)

    this.generic_service.updateExistingCustomerInfoStatus(body).subscribe(
      (res:any)=>{
        document.getElementById("closeModalButton")?.click()
        this.getAllECRequests()
      }
    )
  }

  rejectEC(){
    let body = {
      "customerId": this.data[0].existingCustomerInfoId,
      "cid": this.data[0].cid,
      "existingCustomerInfoStatus": {
        "note": "",
        "status": "REJECTED",
        "updatedDate": 0
      }
    }

    this.generic_service.updateExistingCustomerInfoStatus(body).subscribe(
      (res:any)=>{
        document.getElementById("closeModalButton")?.click()
        this.getAllECRequests()
      }
    )
  }

  imageUrlSelect(url:any){
    this.imageUrl = url
  }

  closeImage(){
    this.imageUrl = ""
  }

  editEC(){
    this.isEditEC = true
  }

  customerRegistration() {
    if(!this.editForm.valid){
      this.toastr.error('All field required');
      return
    }
      const body = {
        "version": 0,
        "isActive": true,
        "description": this.data[0].description,
        "id": this.data[0].id,
        "existingCustomerInfoId": this.data[0].existingCustomerInfoId,
        "customerId": this.editForm.get('customerId').value,
        "name": this.editForm.get('name').value,
        "info": this.data[0].info,
        "mobileNo": this.data[0].mobileNo,
        "altMobileNo": this.data[0].altMobileNo,
        "email": this.editForm.get('email').value,
        "altEmail": this.data[0].altEmail,
        "installationAddress": this.editForm.get('installationAddress').value,
        "photoUrl": this.data[0].photoUrl,
        "idProofUrl": this.data[0].idProofUrl,
        "addressProofUrl": this.data[0].addressProofUrl,
        "keyValuePairs": this.data[0].keyValuePairs,
        "latestStatus": this.data[0].latestStatus,
        "statusList": this.data[0].statusList,
        "cid": this.data[0].cid,
        "applicationFormFor": this.data[0].applicationFormFor,
        "buildingUrl": this.data[0].buildingUrl,
        "lat": this.data[0].lat,
        "lng": this.data[0].lng,
        "deviceInfoList": this.data[0].deviceInfoList,
      }
   
      console.log(body)
      this.generic_service.updateExistingCustomerInfo(body).subscribe(
        (res:any)=>{
          document.getElementById("closeEditButton")?.click()
          this.getAllECRequests()
          this.data = []
        },
        (error: any) =>{
          console.log(error)
        }

      )

  }
}